import Span from '../../tag/Span';
import { formatCustom, formatTime } from '../../../utils/TimeUtils';
import Row from '../../tag/Row';

const AppointmentTime = ({ selectedTime }) => {
  return (
    <Row>
      <Span len="4" sm-len="12">
        <span className="appointment-modal-label">Uusi aika</span>
      </Span>
      <Span len="8" sm-len="12">
        {/* Here it is assumed that dates do not span over days */}
        <span className="appointment-modal-text">
          {`${formatCustom(
            selectedTime.dateStart,
            'DD. MMMM'
          )}ta klo ${formatTime(selectedTime.dateStart)} - ${formatTime(
            selectedTime.dateEnd
          )}`}
        </span>
      </Span>
    </Row>
  );
};

export default AppointmentTime;
